<template>
  <div>
    <section-header heading="2" ja="SNSアカウントでログイン"/>
    <div class="snsArea">
      <div class="line">
        <v-avatar size="52px" tile @click="onLineTokenRequest()">
          <v-img src="@/assets/Png/SNS/LINE_SOCIAL_Basic.png"></v-img>
        </v-avatar>
      </div>
      <div class="twitter">
        <v-avatar size="52px" tile @click="onTwitterTokenRequest()">
          <v-img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png"></v-img>
        </v-avatar>
      </div>
    </div>

    <section-header heading="2" ja="メールアドレスでログイン"/>
    <div class="mailArea">
      <p-text-field
        placeholder="メールアドレス"
        v-model="local"
        @click="onLocalCancel" />
      <rule v-if="domain === 'それ以外'">@以降も全て入力してください</rule>
      <p-select
        :items="domains"
        v-model="domain" />
      <p-text-field
        placeholder="パスワード"
        type="password"
        v-model="password"
        @click="onPasswordCancel" />
    </div>
    <normal-btn
      :disabled="!validForm"
      @click="onMailAddressLogin">メールアドレスでログイン</normal-btn>
    <div class="infoLink">
      <div class="link-text" @click="onAboutWeb02">ログインできない</div>
      <div class="link-text" @click="onPasswordForgot">パスワードが分からない</div>
    </div>

    <section-header heading="2" ja="初めての方はこちら"/>
    <normal-btn @click="onRegistration">無料会員登録する</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import PSelect from '../components/PSelect'
import PTextField from '../components/PTextField'
import NormalBtn from '../components/NormalBtn'
import Rule from '../components/Rule'
import Line from '../mixins/line.js'
import Twitter from '../mixins/twitter'
import Protobuf from '../mixins/protobuf.js'
import Screen from '../mixins/screen.js'
import Validator from '../mixins/validator'
import { domains } from "../assets/js/domain"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Login",
  components: {
    PSelect,
    PTextField,
    SectionHeader,
    NormalBtn,
    Rule
  },
  mixins: [
    Line,
    Twitter,
    Protobuf,
    Screen,
    Validator
  ],
  data () {
    return {
      local: '',
      domain: '@docomo.ne.jp',
      password: '',
      domains: domains,
      to: "/"
    }
  },
  computed: {
    mailAddress() {
      if(this.domain === 'それ以外') {
        return this.local
      } else {
        return this.local + this.domain
      }
    },
    validForm() {
      let err = this.validMailAddress(this.mailAddress)
      if (err !== null) {
        return false
      }
      err = this.validPassword(this.password)
      if (err !== null) {
        return false
      }
      return true
    },
  },
  methods: {
    onAboutWeb02() {
      this.$router.push("/AboutWeb02")
    },
    onLineTokenRequest() {
      this.getLineOAuthToken()
    },
    onLineLogin(accessToken, userId) {
      const cmdNo = pb.LoginReq.CommandNo.COMMAND_NO
      const message = pb.LoginReq.create({
        loginType: pb.LoginReq.LoginType.LINE,
        lineUserId: userId,
        lineAccessToken: accessToken
      })
      const encoded = pb.LoginReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.LoginResp.Status.SUCCESS) {
            this.$store.dispatch('saveLineAccessToken', accessToken)
            this.login(decoded)
          } else {
            this.$_error('Error', { title: 'ログイン', statusCode: 400 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'ログイン', statusCode: 100 })
        })
    },
    onTwitterTokenRequest() {
      this.getTwitterOAuthToken()
    },
    onTwitterLogin(accessToken, userId) {
      const cmdNo = pb.LoginReq.CommandNo.COMMAND_NO
      const message = pb.LoginReq.create({
        loginType: pb.LoginReq.LoginType.TWITTER,
        twitterAccessToken: accessToken,
        twitterUserId: userId
      })
      const encoded = pb.LoginReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.LoginResp.Status.SUCCESS) {
            this.$store.dispatch('saveTwitterAccessToken', accessToken)
            this.login(decoded, 'twitter')
          } else {
            this.$_error('Error', { title: 'ログイン', statusCode: 400 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'ログイン', statusCode: 100 })
        })
    },
    login(decoded) {
      this.$store.dispatch('login', {
        token: decoded.token,
        membershipGrade: decoded.membershipGrade,
        mailAddress: decoded.mailAddress,
        playerId: decoded.playerId,
        registrationType: decoded.registrationType
      })
      if (!decoded.isChecking) {
        this.$router.push(this.to)
        return
      }
      this.updateMembership()
        .then(membershipGrade => {
          this.$store.dispatch('saveMembershipGrade', membershipGrade)
          this.$router.push(this.to)
        })
        .catch(statusCode => {
          this.$_error('Error', { title: 'ログイン', statusCode: statusCode })
        })
    },
    onLocalCancel() {
      this.local = ''
    },
    onPasswordCancel() {
      this.password = ''
    },
    onPasswordForgot() {
      this.$router.push('/passwordForgot')
    },
    onMailAddressLogin() {
      console.log('login')
      window.scrollTo(0, 0)
      const cmdNo = pb.LoginReq.CommandNo.COMMAND_NO
      const message = pb.LoginReq.create({
        loginType: pb.LoginReq.LoginType.MAIL_ADDRESS,
        mailAddress: this.mailAddress,
        password: this.password
      })
      const encoded = pb.LoginReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status == pb.LoginResp.Status.SUCCESS) {
            this.$store.dispatch('savePassword', this.password)
            this.login(decoded)
          } else {
            this.$_error('Error', { title: 'ログイン', statusCode: 410 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'ログイン', statusCode: 100 })
        })
    },
    onRegistration () {
      this.$router.push('/accountRegistration1')
    },
    updateMembership() {
      return new Promise((resolve, reject) => {
        const cmdNo = pb.BuyMembershipUpdateReq.CommandNo.COMMAND_NO
        const message = pb.BuyMembershipUpdateReq.create()
        const encoded = pb.BuyMembershipUpdateReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            // レシートチェック状態 -2:ゲームサーバー側エラー -1:未処理 0:処理完了 1以上:レシートチェック側エラー
            if (decoded.receiptStatus === 0) {
              resolve(decoded.membershipGrade)
            } else if (decoded.receiptStatus === -1) {
              this.reRequestUpdate()
            } else {
              reject(100)
            }
          })
          .catch(() => {
            reject(100)
          })
      })
    },
    reRequestUpdate() {
      this.$store.state.isConnecting = true
      setInterval(() => {
        this.$store.state.isConnecting = false
        this.updateMembership()
      }, 1000);
    }
  },
  mounted () {
    sessionStorage.setItem('prevPage', '/Login');
    let component = this
    this.to = this.$route.query.to ? this.$route.query.to : "/"
    this.getTwitterAccessToken.call(this).then(data =>{
      if (data === undefined) {
        return
      }
      component.onTwitterLogin(data.token, data.userId)
    }).catch(() => {
      this.$_error('Error', { title: 'ログイン', statusCode: 400 })
    })

    this.getLineAccessToken.call(this).then(data => {
      if (data === undefined) {
        return
      }
      component.onLineLogin(data.token, data.userId)
    }).catch(() => {
      this.$_error('Error', { title: 'ログイン', statusCode: 400 })
    })
  }
}
</script>

<style lang="scss" scoped>
.snsArea {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .twitter { margin-left: 40px; }
}
.checkbox-label {
  font-size: 13px;
  letter-spacing: -0.1em;
  margin-left: 2px;
}
.infoLink {
  margin-top: 20px;
  padding: 0 30px;
  cursor: pointer;
  & > div {
  margin-top: 15px;
  padding-right: 30px;
  text-align: right;
  font-size: 10px;
  color: #F63C5B;
  background-image:
    linear-gradient(to left, #F63C5B, #F63C5B),
    linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
  background-repeat: no-repeat;
  background-size: 24px 1px, 8px 8px;
  background-position: right 70%, right 40%;
  }
}
.textLink {
  margin: 20px 30px 0;
  font-size: 12px;
  .textLink { color: #DA2240; }
  & > span {
    color: #DA2240;
  }
}
</style>
